export enum ControlSize {
    small = 'sm',
    normal = '',
    large = 'lg'
}
